import { useEffect, useState } from "react";

import { useLatestRequestGuard } from "@/hooks/useLatestRequestGuard";
import { StoreService } from "@/services/features/StoreService";

export interface StoreArea {
  id: number;
  name: string;
}

const emptyAreas: StoreArea[] = [];

export const useStoreAreas = (storeId: number | null) => {
  const beginRequest = useLatestRequestGuard();
  const [areas, setAreas] = useState<StoreArea[]>(emptyAreas);
  const [loading, setLoading] = useState(Boolean(storeId));

  useEffect(() => {
    const isCurrent = beginRequest();
    setAreas(emptyAreas);
    setLoading(Boolean(storeId));
    if (!storeId) return;

    const load = async () => {
      try {
        const response = await StoreService.getInstance().getChangingRoomsByStore(storeId);
        if (!isCurrent()) return;
        if (!response.success || !response.data) {
          console.error("Failed to load store areas:", response.error);
          return;
        }
        setAreas(
          response.data.flatMap(({ changingRoomGroup }) =>
            changingRoomGroup?.id === undefined
              ? []
              : [{ id: changingRoomGroup.id, name: changingRoomGroup.name }],
          ),
        );
      } catch (error) {
        if (isCurrent()) console.error("Failed to load store areas:", error);
      } finally {
        if (isCurrent()) setLoading(false);
      }
    };

    void load();
  }, [beginRequest, storeId]);

  return { areas, loading };
};
